import React, {
  useState,
  useEffect,
  useCallback,
  useImperativeHandle,
  forwardRef,
} from "react";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, OutlinedInput } from "@mui/material";
import { SearchInputComponentProps } from "./search-input-component.props";
import AlertComponent from "../alert-component/alert-component";
import "./search-input-component.scss";
import CloseIcon from "@mui/icons-material/Close";

const SearchInputComponent = forwardRef<any, SearchInputComponentProps>(
  (
    {
      placeholder = "",
      isReset,
      onSearch,
      localSearchText,
    },
    ref
  ) => {
    const [searchText, setSearchText] = useState<any>(localSearchText || "");
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState<
      "success" | "error" | "info" | "warning"
    >("success");

    useImperativeHandle(ref, () => ({
      clear: () => {
        setSearchText("");
      },
    }));

    useEffect(() => {
      if (isReset) setSearchText("");
    }, [isReset]);

    const handleSearch = useCallback(() => {
      // if (searchText.trim() === "!") {
      //   setAlertMessage('Search cannot be performed with just "!"');
      //   setAlertType("info");
      //   setAlertOpen(true);
      //   return;
      // }

      const value = searchText.trim();

      if (value) {
        onSearch(value);
      }
    }, [searchText, onSearch]);

    const handleSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        // keep original behavior: only search if there is text
        if (searchText?.trim()) handleSearch();
      }
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setSearchText(value);

      // ✅ when cleared, trigger listing refresh
      if (!value.trim()) {
        onSearch("");
      }
    };

    const handleAlertClose = () => {
      setAlertOpen(false);
    };

    useEffect(() => {
      if (localSearchText !== undefined) {
        setSearchText(localSearchText);
      }
    }, [localSearchText]);

    return (
      <Box>
        <AlertComponent
          message={alertMessage}
          type={alertType}
          open={alertOpen}
          onClose={handleAlertClose}
        />

        <div className="form-search-input-component">
          <OutlinedInput
            id="search-leads"
            className="search-input"
            placeholder={placeholder}
            onChange={handleSearchChange}
            onKeyDown={handleSearchKeyDown}
            value={searchText}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon
                  onClick={handleSearch}
                  className="search-icon"
                  titleAccess="Click to Search"
                  style={{ cursor: "pointer" }}
                />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                {searchText && (
                  <CloseIcon
                    className="clear-icon"
                    onClick={() => {
                      setSearchText("");
                      onSearch("");
                    }}
                    style={{ cursor: "pointer", marginRight: 8 }}
                  />
                )}
              </InputAdornment>
            }
            fullWidth
            inputProps={{
              style: {
                whiteSpace: "nowrap",
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "40px",
              },
              borderRadius: "8px",
              "& .MuiInputBase-input": {
                padding: "12px 10px",
              },
            }}
          />
        </div>
      </Box>
    );
  }
);

export default SearchInputComponent;
